import { connect } from 'react-redux';
import MobileTopbar, { MobileTopbarProps } from '../components/MobileTopbar';
import { getCanGoBack } from '../redux/selectors';

type StateProps = Omit<MobileTopbarProps, 'onSearchFocus'>;

const mapStateToProps = (state, ownProps): StateProps => ({
  hasSubNav: ownProps.hasSubNav || false,
  canGoBack: getCanGoBack(state),
  location: state.location.type,
});

export default connect(mapStateToProps)(MobileTopbar);
